import React from 'react';

export default class Muted extends React.Component {
  render () {
    return (
      <div className="c-muted">
        {this.props.content}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Components/Muted.js